import { routeAlias, routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const courtRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.courts,
    name: routeNames.courts,
    component: () => import('@/pages/courts/CourtsView.vue'),
    meta: {
      permission: 'courts.read.all',
      icon: 'material-symbols-outlined',
      iconText: 'account_balance',
      labelKey: 'courts',
    },
  },
  {
    path: routePaths.courtCreation,
    name: routeNames.courtCreation,
    component: () => import('@/pages/courts/AddEditCourtView.vue'),
    meta: {
      permission: 'courts.write.all',
      labelKey: 'new_m',
      rootRouteName: routeNames.courts,
    },
  },
  {
    path: routePaths.courtEdit,
    name: routeNames.courtEdit,
    alias: routeAlias.courtEdit,
    component: () => import('@/pages/courts/AddEditCourtView.vue'),
    meta: {
      permission: 'courts.write.all',
      labelKey: 'edit',
      rootRouteName: routeNames.courts,
    },
  },
]
